import { useState } from 'react';
import { putLogisticServicePaymentLink } from 'services/services';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useRegisterLogisticServicePaymentLink = () => {
  const [isLoading, setIsLoading] = useState(false);

  const register = async (id: number, paymentLink: string): Promise<boolean> => {
    setIsLoading(true);
    try {
      if (!paymentLink.trim()) {
        displayErrorNotification({ customJSXMessage: <>El link de pago es obligatorio</> });
        return false;
      }
      const body = { paymentLink: paymentLink.trim() };

      await putLogisticServicePaymentLink(id, body);

      displaySuccessNotification({ customJSXMessage: <>Se han guardado los cambios</> });
      return true;
    } catch (error) {
      displayErrorNotification();
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, register };
};
